import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField
} from '@mui/material';
import {
  deleteObstacle,
  getObstacles,
  newObstacle,
  setCellId,
  updateObstacle
} from 'actions/obstacleActions';
import { TileLayer } from '@deck.gl/geo-layers/typed';
import { getCells } from 'actions/orderActions';
import { useAppSelector } from 'hooks/redux';
import React, { useEffect, useRef, useState } from 'react';
import {
  MapContext,
  MapRef,
  NavigationControl,
  StaticMap,
  ViewState
} from 'react-map-gl';

import { useDispatch } from 'react-redux';
import DeckGL from '@deck.gl/react/typed';
import { getGeofences } from 'actions/geofenceActions';
import { selectGeofences } from 'reducers/geofencesReducer';
import {
  EditableGeoJsonLayer,
  DrawPolygonMode,
  ModifyMode,
  ViewMode
} from 'nebula.gl';
import { BitmapLayer, GeoJsonLayer } from '@deck.gl/layers/typed';
import { selectCells } from 'selectors/ordersSelector';
import {
  selectObstacleCellId,
  selectObstacles
} from 'reducers/obstaclesReducer';
import { balbrigganCoords, cellNameCoords } from '../../constants';
interface Mode {
  id: string;
  text: string;
  handler: any; // Replace 'any' with actual type if known
}

const MODES: Mode[] = [
  { id: 'drawPolygon', text: 'Draw Polygon', handler: DrawPolygonMode },
  { id: 'editing', text: 'Edit Feature', handler: ModifyMode },
  { id: 'view', text: 'View Feature', handler: ViewMode }
];

interface Viewport {
  width: number;
  height: number;
  longitude: number;
  latitude: number;
  zoom: number;
}

const DEFAULT_VIEWPORT: Viewport = {
  width: 800,
  height: 600,
  longitude: balbrigganCoords[1],
  latitude: balbrigganCoords[0],
  zoom: 14
};

type Key =
  | 'NO_FLY'
  | 'SCHOOL'
  | 'HOSPITAL'
  | 'SERVICES_999'
  | 'INFRASTRUCTURE'
  | 'MILITARY'
  | 'RAILWAY'
  | 'RESIDENTIAL'
  | 'COMMERCIAL'
  | 'OTHER';
type KeyColorType = {
  key: Key;
  color: string | [number, number, number];
};

export const obstacleData: { [key: number]: KeyColorType } = {
  1: { key: 'NO_FLY', color: [0, 0, 0] },
  2: { key: 'SCHOOL', color: [255, 192, 203] },
  3: { key: 'HOSPITAL', color: [255, 0, 0] },
  4: { key: 'SERVICES_999', color: [102, 0, 102] },
  5: { key: 'INFRASTRUCTURE', color: [255, 128, 0] },
  6: { key: 'MILITARY', color: [0, 255, 255] },
  7: { key: 'RAILWAY', color: [255, 0, 255] },
  8: { key: 'RESIDENTIAL', color: [0, 0, 255] },
  9: { key: 'COMMERCIAL', color: [0, 161, 201] },
  12: { key: 'OTHER', color: [255, 255, 255] }
};

export const MBObstacles: React.FC = () => {
  const [modeId, setModeId] = useState<string | null>('drawPolygon');
  const [selectedFeatureIndexes, setSelectedFeatureIndexes] = React.useState(
    []
  );
  const [editedfeatureIndexes, setEditedfeatureIndexes] = React.useState([]);

  const obstacles = useAppSelector(selectObstacles);
  const [modeHandler, setModeHandler] = useState<any | null>(null); // Replace 'any' with actual type if known
  const mapRef = useRef<MapRef | null>(null);
  const cells = useAppSelector(selectCells);
  const cell = useAppSelector(selectObstacleCellId);
  const [obstacleKey, setObstacleKey] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [newObstacleKey, setNewObstacleKey] = useState<boolean>(false);

  const [features, setFeatures] = React.useState({
    type: 'FeatureCollection',
    features: obstacles?.map(o => {
      return {
        ...o?.geoJson,
        properties: {
          groundRisk: o?.groundRisk,
          color: obstacleData[o?.groundRisk]?.color
        }
      };
    })
  });
  const [name, setName] = useState('');

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedName = event.target.value;

    setName(updatedName);
  };

  const [initialViewState, setInitialViewState] = useState<ViewState>({
    latitude: cellNameCoords['BALBRIGGAN'][0],
    longitude: cellNameCoords['BALBRIGGAN'][1],
    zoom: 11,
    bearing: 0,
    pitch: 0
  });

  useEffect(() => {
    const matchingCell = cells?.find(c => c?.id === cell);
    if (cell && cells) {
      const coords = [matchingCell?.centerLatitude, matchingCell?.centerLongitude];

      setInitialViewState({
        latitude: coords[0],
        longitude: coords[1],
        zoom: 14,
        pitch: 0,
        bearing: 0
      });
    }
  }, [cell]);

  const geofences = useAppSelector(selectGeofences);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCells());
    dispatch(getGeofences());
  }, []);
  useEffect(() => {
    dispatch(getObstacles(cell, false));
  }, [cell, cells]);
  useEffect(() => {
    setFeatures({
      type: 'FeatureCollection',
      features: obstacles?.map(o => {
        return {
          ...o?.geoJson,
          properties: {
            groundRisk: o?.groundRisk,
            color: obstacleData[o?.groundRisk]?.color
          }
        };
      })
    });
  }, [obstacles]);
  useEffect(() => {
    if (modeId === 'editing') {
      const newColor = obstacleData[obstacleKey]?.color;

      setFeatures({
        type: 'FeatureCollection',
        features: features?.features?.map((o, i) => {
          if (selectedFeatureIndexes[0] === i) {
            return {
              ...o,
              properties: {
                groundRisk: obstacleKey,
                color: newColor
              }
            };
          } else {
            return o;
          }
        })
      });
    } else {
      const newColor = obstacleData[obstacleKey]?.color;

      setFeatures({
        type: 'FeatureCollection',
        features: features?.features?.map((o, i) => {
          if (features?.features.length - 1 === i) {
            return {
              ...o,
              properties: {
                groundRisk: obstacleKey,
                color: newColor
              }
            };
          } else {
            return o;
          }
        })
      });
    }
  }, [obstacleKey]);

  useEffect(() => {
    const mode = MODES.find(m => m.id === modeId);

    const newModeHandler = mode ? new mode.handler() : null;
    newModeHandler.handleKeyUp = () => {};
    newModeHandler && setModeHandler(newModeHandler);
  }, [modeId]);

  const switchMode = (event: SelectChangeEvent<string>) => {
    const newModeId = event.target.value === modeId ? null : event.target.value;
    const mode = MODES.find(m => m.id === newModeId);
    setModeId(newModeId);

    const newModeHandler = mode ? new mode.handler() : null;
    newModeHandler.handleKeyUp = () => {};

    newModeHandler && setModeHandler(newModeHandler);
  };
  const selectCell = (event: SelectChangeEvent<string>) => {
    // @ts-ignore
    dispatch(setCellId(event.target.value));
  };
  const selectType = (event: SelectChangeEvent<number>) => {
    if (typeof event.target.value === 'number') {
      setObstacleKey(event.target.value);
    } else if (typeof event.target.value === 'string') {
      setObstacleKey(parseInt(event.target.value));
    }
  };
  const reset = () => {
    setName(null);
    setObstacleKey(0);
    setNewObstacleKey(false);
    setSelectedFeatureIndexes([]);
  };

  const addObstacle = async () => {
    try {
      setLoading(true);
      await dispatch(
        newObstacle(
          obstacleKey,
          name,
          cell,
          features?.features[features?.features.length - 1]
        )
      );
      setLoading(false);

      reset();
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };
  const changeObstacle = async () => {
    try {
      setLoading(true);

      await dispatch(
        updateObstacle(
          obstacles?.[selectedFeatureIndexes[0]],
          obstacleKey,
          name,
          cell,
          features?.features[selectedFeatureIndexes[0]]
        )
      );
      setLoading(false);

      reset();
    } catch (err) {
      setLoading(false);

      console.error(err);
    }
  };
  const removeObstacle = async () => {
    try {
      setLoading(true);

      await dispatch(
        deleteObstacle(obstacles?.[selectedFeatureIndexes[0]]?.id, cell)
      );
      setLoading(false);

      reset();
    } catch (err) {
      setLoading(false);

      console.error(err);
    }
  };
  const discardObstacle = e => {
    setFeatures({
      type: 'FeatureCollection',
      features: features?.features
        ?.map((o, i) => {
          if (features?.features.length - 1 === i) {
            return null;
          } else {
            return o;
          }
        })
        .filter(Boolean)
    });
    setModeId('drawPolygon');
  };

  function onLayerClick(info) {
    if (info.index === selectedFeatureIndexes[0]) {
    } else {
      setSelectedFeatureIndexes(info.object ? [info.index] : []);
    }
  }

  const renderAddFeature = () => {
    return (
      <>
        {newObstacleKey ? (
          <FormControl style={{ width: '100%' }}>
            <Select
              disabled={loading}
              value={obstacleKey}
              onChange={selectType}>
              {Object.entries(obstacleData)?.map(([key, obstacleType]) => (
                <MenuItem key={key} value={key}>
                  {obstacleType.key}
                </MenuItem>
              ))}
              <MenuItem key={0} value={0}>
                Select Obstacle Type
              </MenuItem>
            </Select>
          </FormControl>
        ) : null}
        {newObstacleKey ? (
          <>
            <Box sx={{ width: '100%' }}>
              <TextField
                disabled={loading}
                value={name}
                onChange={handleNameChange}
                label="Name"
                variant="outlined"
              />
              <Button
                disabled={obstacleKey === 0 || !name || loading}
                sx={{ backgroundColor: 'white' }}
                onClick={addObstacle}
                fullWidth>
                Save
              </Button>
            </Box>
            <Box sx={{ width: '100%' }}>
              <Button
                sx={{ backgroundColor: 'white' }}
                onClick={discardObstacle}
                fullWidth>
                Discard
              </Button>
            </Box>
          </>
        ) : null}
      </>
    );
  };

  const renderEditFeature = () => {
    const selectedObstacle = obstacles?.[selectedFeatureIndexes[0]];

    return (
      <>
        {selectedObstacle ? (
          <FormControl style={{ width: '100%' }}>
            <Select
              disabled={loading}
              value={
                obstacleKey === 0 ? selectedObstacle?.groundRisk : obstacleKey
              }
              onChange={selectType}>
              {Object.entries(obstacleData)?.map(([key, obstacleType]) => (
                <MenuItem key={key} value={key}>
                  {obstacleType.key}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : null}
        {selectedObstacle ? (
          <>
            <TextField
              disabled={loading}
              value={name || selectedObstacle?.name}
              onChange={handleNameChange}
              label="Name"
              variant="outlined"
            />
            <Box sx={{ width: '100%' }}>
              <Button
                disabled={loading}
                sx={{ backgroundColor: 'white' }}
                onClick={changeObstacle}
                fullWidth>
                Update
              </Button>
            </Box>
            <Box sx={{ width: '100%' }}>
              <Button
                disabled={loading}
                sx={{ backgroundColor: 'white' }}
                onClick={removeObstacle}
                fullWidth>
                Delete
              </Button>
            </Box>
          </>
        ) : null}
      </>
    );
  };

  const renderToolbar = () => {
    return (
      <Box
        sx={{
          position: 'absolute',
          top: 200,
          right: 0,
          width: 200,
          backgroundColor: 'white',
          marginRight: 1,
          pointerEvents: 'all'
        }}>
        <FormControl style={{ width: '100%' }}>
          <Select value={cell || ''} onChange={selectCell}>
            {cells?.map(cell => (
              <MenuItem key={cell.id} value={cell.id}>
                {cell.cellName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl style={{ width: '100%' }}>
          <Select value={modeId || ''} onChange={switchMode}>
            {MODES.map(mode => (
              <MenuItem key={mode.id} value={mode.id}>
                {mode.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {modeId === 'editing' ? renderEditFeature() : renderAddFeature()}
      </Box>
    );
  };

  return (
    <>
      <DeckGL
        initialViewState={initialViewState}
        controller={{
          touchRotate: false,
          dragRotate: false,
          keyboard: false
        }}
        onClick={onLayerClick}
        // @ts-ignore
        ContextProvider={MapContext.Provider}
        layers={[
          new TileLayer({
            id: 'satellite-tiles',
            data: 'https://tiles.manna.aero/{z}/{x}/{y}.png',
            minZoom: 12,
            maxZoom: 22,
            tileSize: 256,
            renderSubLayers: (props: any) => {
              const {
                bbox: { west, south, east, north }
              } = props.tile;
              return new BitmapLayer(props, {
                // @ts-ignore
                data: null,
                image: props.data,
                bounds: [west, south, east, north]
              });
            }
          }),

          geofences.map(fence => {
            return new GeoJsonLayer({
              id: 'path-layer-fences' + fence.id,
              data: fence.geoJson,
              getWidth: 2,
              widthUnits: 'pixels',
              pickable: true,
              lineWidthScale: 0.5,
              lineWidthMinPixels: 0.5,
              getLineColor: [255, 255, 255],
              filled: false,
              getPointRadius: 0.5,
              getLineWidth: 8,
              opacity: 0.3
            });
          }),

          // @ts-ignore
          new EditableGeoJsonLayer({
            id: 'geojson-layer',
            data: features,

            mode: modeHandler,
            selectedFeatureIndexes,
            getLineColor: f => {
              return f.properties?.color;
            },
            getFillColor: f => {
              return f.properties?.color;
            },
            opacity: 0.4,

            onEdit: edited => {
              if (edited?.editType === 'addFeature') {
                setNewObstacleKey(true);
                setModeId('view');
              } else if (edited?.editType === 'finishMovePosition') {
                setEditedfeatureIndexes([
                  ...editedfeatureIndexes,
                  edited.editContext?.featureIndexes?.[0]
                ]);
              }
              setFeatures(edited.updatedData);
            },
          })
        ]}>
        <StaticMap
          ref={mapRef}
          mapStyle={'mapbox://styles/mapbox/satellite-v9'}
          mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}></StaticMap>
        <NavigationControl
          style={{ position: 'absolute', top: 100, right: 10 }}
        />
      </DeckGL>
      {renderToolbar()}
    </>
  );
};
